import type { IconDef } from '../types';

export const lightbulb: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M8.25 9.5C8.25 7.01472 9.92893 5 12 5C14.0711 5 15.75 7.01472 15.75 9.5C15.75 10.9439 15.0341 12.2337 13.9153 13.0594C13.3435 13.4815 13 14.151 13 14.8618V15H11V14.8618C11 14.151 10.6565 13.4815 10.0847 13.0594C8.96587 12.2337 8.25 10.9439 8.25 9.5Z',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      d: 'M10 18H14',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
    },
    {
      d: 'M10.75 21H13.25',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '2',
      strokeLinecap: 'round',
    },
  ],
};
